/* eslint-disable max-statements */
import { useMutation, useQuery } from "@apollo/client";
import prepareComponent from "@bluframe/grapple/prepareComponent";
import useToggle from "@bluframe/grapple/useToggle";
import { mutations, queries } from "@bluframe/mightychroma-mightytool-graphql-schema";
import useUser from "hooks/useUser";
import { useHistory, useParams } from "react-router-dom";
import Item from "./Item";
const { news: { GET_OUTLETS, GET_OUTLET_BY_ID } } = queries;
const { news: { DELETE_OUTLET, UPDATE_OUTLET } } = mutations;
const usePrepareComponent = () => {
    const [isEditing, toggleIsEditing] = useToggle();
    const history = useHistory();
    const params = useParams();
    const { isAdmin, isEditor } = useUser();
    const { data, loading } = useQuery(GET_OUTLET_BY_ID, { fetchPolicy: "network-only", variables: { id: params.id } });
    const [updateOutlet, { loading: isSaveLoading }] = useMutation(UPDATE_OUTLET, {
        refetchQueries: [{ query: GET_OUTLET_BY_ID, variables: { id: params.id } }]
    });
    const [deleteOutlet] = useMutation(DELETE_OUTLET, { refetchQueries: [GET_OUTLETS] });
    const onCancel = () => {
        toggleIsEditing();
    };
    const onEdit = () => {
        toggleIsEditing();
    };
    const onPublishToggle = () => {
        updateOutlet({
            variables: {
                id: params.id,
                outletUpdateInput: { isPublished: !data?.getOutletById.isPublished }
            }
        });
    };
    const onSave = (outletUpdate) => {
        if (!params.id || !outletUpdate.name || !outletUpdate.slug)
            return;
        updateOutlet({
            onCompleted: () => toggleIsEditing(),
            variables: {
                id: params.id,
                outletUpdateInput: {
                    ...outletUpdate,
                    logoImageId: outletUpdate.logoImageId
                        ? Number(outletUpdate.logoImageId)
                        : undefined,
                    splashImageId: outletUpdate.splashImageId
                        ? Number(outletUpdate.splashImageId)
                        : undefined
                }
            }
        });
    };
    const onDelete = () => {
        if (!params.id)
            return;
        deleteOutlet({
            onCompleted: () => history.push("/news/outlets"),
            variables: { id: params.id }
        });
    };
    return {
        isAdmin,
        isEditing,
        isEditor,
        isSaveLoading,
        item: data?.getOutletById,
        loading,
        onCancel,
        onDelete,
        onEdit,
        onPublishToggle,
        onSave
    };
};
export default prepareComponent(usePrepareComponent)(Item);
